export default "__VITE_ASSET__C5Jjqif7__"